export const getDelayedCreationStyles = () => (
  import(/* webpackMode: 'eager' */'../styles')
    .then(({ getEntityCreationStyle }) => ({
      getDelayedStyles: getEntityCreationStyle,
    }))
);
